
function getQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    var qs = se.replace("?", "");
    if (!param || param === "") return qs;
    if (qs === "") return null;

    var qa = qs.split("&");
    for (var i = 0; i < qa.length; i++) {
        var q = qa[i];
        if (q.indexOf("=") > -1) {
            var a = q.split("=");
            if (a[0] === param) return a[1];
        } else {
            if (q === param) return "";
        }
    }
}
function setQuery(param, value, search) {
    var se = search !== undefined ? search : window.location.search;
    if (se !== "") {
        var qa = se.replace("?", "").split("&");
        var qa2 = [];
        var isNew = true;

        for (var i = 0; i < qa.length; i++) {
            var qi = qa[i];
            var j = qi.indexOf("=");
            var qname = j > -1 ? qi.substring(0, j) : qi;
            if (qname === param) {
                if (value && value !== "") {
                    qi = param + "=" + encodeURIComponent(value);
                } else {
                    qi = param;
                }
                isNew = false;
            }
            qa2.push(qi);
        }
        if (isNew) {
            if (value && value !== "") {
                qa2.push(param + "=" + encodeURIComponent(value));
            } else {
                qa2.push(param);
            }
        }

        return qa2.join("&");
    } else if (value && value !== "") {
        return param + "=" + encodeURIComponent(value);
    } else {
        return param;
    }
}
function removeQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    if (!param || param === "")
        return se.replace("?", "");

    var qa = se.replace("?", "").split("&");
    var qa2 = [];
    for (var i = 0; i < qa.length; i++) {
        var qi = qa[i];
        var j = qi.indexOf("=");
        var qname = j > -1 ? qi.substring(0, j) : qi;

        if (qname !== param)
            qa2.push(qi);
    }

    return qa2.join("&");
}
function pushQueryState(q, x, state, title) {
    var qs = "";
    var url = window.location.pathname;

    if (!q || typeof q !== "string") {
        return null;
    }

    if (x === null || x === undefined) {
        qs = removeQuery(q);
    } else {
        qs = setQuery(q, x);
    }
    if (qs !== "") {
        qs = "?" + qs;
    }
    url += qs + window.location.hash;

    return window.history.pushState(state, (title ? title : q + " " + x), url);
}

function moveElementWithTinyMCE($el, fn) {
    /*Issue: moving the DOM element of the mce container bugs the editor where 
     it loses the content and becomes uneditable. To fix this, remove its 
     instance and reinitalize with the textarea.*/
    if ($el.has(".mce-container").length) {
        var id = $el.find("textarea.form-input").attr("id"),
                settings = tinymce.settings;

        tinymce.settings = tinymce.get(id).settings;
        fn();
        tinymce.EditorManager.execCommand("mceRemoveEditor", false, id);
        tinymce.EditorManager.execCommand("mceAddEditor", false, id);
        tinymce.settings = settings;
    } else {
        fn();
    }
}

function escapeXMLEntities(s) {
    return s.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
}
function escapeXMLEntities2(s) {
    return s.replace(/&(?!amp;([a-z]+|#[0-9]+);)/g, "&amp;");
}

function randomHex() {
    return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
}
function randomIdNumber(length) {
    return Math.floor((1 + Math.random()) * Math.pow(10, length ? length : 4)).toString().substring(1);
}
function randomIdLetter(length) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var chars = "";
    var l = length ? length : 6;
    for (var i = 0; i < l; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}
function randomIdMix(length) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    var chars = randomIdLetter(1);
    var l = length ? length - 1 : 12;
    for (var i = 0; i < l; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}

function scrollToElement(event, scroller, element, offset, speed) {
    if (event) {
        var targ = event.currentTarget || this;
        var dataset = targ.dataset;
        var ctn = $(dataset.ctn || "html, body");
        var offsetEl = $(dataset.offsetElement);
        var oh = offsetEl[0] ? offsetEl.height() : 0;

        ctn.animate({
            scrollTop: $("#" + dataset.id).offset().top - oh
        }, 300);
    } else {
        $(scroller).animate({
            scrollTop: $(element).offset().top - offset
        }, speed);
    }
}
